<template>
    <div>
    <div class="mb25">
        <label class="order__input-label" :for="localFormName + '_' + localInputName">{{ this.localInputLabel }}</label>
        <select
                v-model="localDaySelected"
                class="order__input order__input--date"
                v-bind:id="localFormName + '_' + localInputName"
                v-bind:name="localFormName+'['+localInputName+']'"
                @change="onChangeDay()"
        >
            <option v-for="day in localDays" :selected="localDaySelected === day">{{ day }}</option>
        </select>
        <div v-show="this.localShowNearDate" class="order__input-note">Ближайшая дата доставки Вашего заказа: {{this.localDays[0]}}</div>
    </div>
    <div class="mb25" v-show="localShowInterval">
        <label class="order__input-label" :for="localFormName + '_deliv_interval'">Интервал доставки</label>
        <select
                v-model="localIntervalSelected"
                class="order__input order__input--select"
                v-bind:id="localFormName + '_deliv_interval'"
                v-bind:name="localFormName + '[deliv_interval]'"
                @change="onChangeInterval()"
        >
            <option v-for="interval in localIntervals" :selected="localIntervalSelected === interval">{{ interval }}</option>
        </select>
    </div>
    </div>
</template>

<script>
    export default {
        name: "delivery-datetime",
        props: {
            days: {
                type : Array
            },
            intervals: {
                type: Array,
                default() {return []}
            },
            day_selected: {
                type: String,
            },
            interval_selected: {
                type: String,
            },
            input_name: {
                type: String,
                default: 'deliv_day'
            },
            form_name: {
                type: String,
                default: 'DelivForm'
            },
            show_interval: {
                type: Boolean,
                default: true
            },
            show_near_date: {
                type: Boolean,
                default: true
            },
            input_label: {
                type: String,
                default: 'Дата доставки'
            }
        },
        data () {
            return {
              localDays : this.days,
              localIntervals : this.intervals,
              localDaySelected: this.day_selected,
              localIntervalSelected: this.interval_selected,
              localInputName: this.input_name,
              localFormName: this.form_name,
              localShowInterval: this.show_interval,
              localShowNearDate: this.show_near_date,
              localInputLabel: this.input_label
            };
        },
        methods: {
            onChangeDay () {
                if(this.localInputName==='deliv_day') {
                    this.$store.dispatch('setDelivDay', this.localDaySelected)
                }
                if(this.localInputName==='deliv_day_sam') {
                    this.$store.dispatch('setDelivDaySam', this.localDaySelected)
                }
            },
            onChangeInterval () {
                this.$store.dispatch('setDelivInterval',this.localIntervalSelected)
            }
        },
        mounted () {
            if(this.localInputName==='deliv_day') {
                this.$store.commit('SET_DELIV_DAY', this.localDaySelected)
            }
            if(this.localInputName==='deliv_day_sam') {
                this.$store.commit('SET_DELIV_DAY_SAM', this.localDaySelected)
            }
            if(this.localShowInterval) {
                this.$store.commit('SET_DELIV_INTERVAL', this.localIntervalSelected)
            }
        }
    }
</script>

<style scoped>
    select {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
    }
    .order__input--date {
        background-color: #fff
    }
</style>
